import { TruncatedHtmlWithLinks } from 'components/Truncate/TruncatedHtmlWithLinks';
import { ListingViewSection } from 'modules/listing/components/ListingView/Section/ListingViewSection';

type Props = {
  languageProficiency: string | null;
  languageProficiencyTruncated: string | null;
};

export function ListingViewLanguageProficiencySection({
  languageProficiency,
  languageProficiencyTruncated,
}: Props) {
  if (!languageProficiency || !languageProficiencyTruncated) return null;

  return (
    <ListingViewSection
      title={
        /* TRANSLATORS: Job Listing Page, section title */
        getText('Level of Language Proficiency')
      }
    >
      <TruncatedHtmlWithLinks
        showMoreLinkTitle={getText('Read more about language proficiency')}
        showLessLinkTitle={getText('Read less about language proficiency')}
        html={languageProficiency}
        truncatedHtml={languageProficiencyTruncated}
      />
    </ListingViewSection>
  );
}
